module.exports = __webpack_public_path__ + "img/prestamo.24eebc59.png";